import React from "react";
import "./Skills.css";
import "./App.css";

const Skills = () => {
  const skillCategories = [
    {
      title: "Languages",
      skills: [
        { name: "Flutter" },
        { name: "Golang" },
        { name: "NodeJS" },
        { name: "Python" },
        { name: "Bash Scripts" },
        { name: "React" },
      ],
    },
    {
      title: "Flutter Development",
      skills: [
        { name: "BLoC Pattern" },
        { name: "GetX" },
        { name: "GoRouter" },
        { name: "App Store Publishing" },
        { name: "Play Store Publishing" },
      ],
    },
    {
      title: "Golang Development",
      skills: [
        { name: "Microservices" },
        { name: "RESTful APIs" },
        { name: "gRPC" },
        { name: "Messaging services" },
        { name: "Database Management Systems" },
      ],
    },
    {
      title: "Strong background in",
      skills: [
        { name: "Microservices" },
        { name: "RESTful APIs" },
        { name: "gRPC" },
        { name: "Messaging services" },
        { name: "Database Management Systems" },
      ],
    },
    {
      title: "Experienced in",
      skills: [
        { name: "Developing full-stack applications" },
        { name: "Creating CI/CD pipelines" },
        { name: "Blockchain" },
      ],
    },
    {
      title: "Knowledgeable in",
      skills: [
        { name: "Github Actions" },
        { name: "Smart Contracts" },
        { name: "Jenkins" },
        { name: "AWS Lambda" },
      ],
    },
  ];

  return (
    <div className="container">
      <h1 className="subtitle">Technical Skills</h1>
      <div
        className="skills-container"
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
          gap: "2rem",
          maxWidth: "1200px", // Limit width to ensure max 3 items per row
          margin: "0 auto",
          "@media (min-width: 1024px)": {
            gridTemplateColumns: "repeat(3, 1fr)",
          },
          "@media (max-width: 1023px) and (min-width: 768px)": {
            gridTemplateColumns: "repeat(2, 1fr)",
          },
          "@media (max-width: 767px)": {
            gridTemplateColumns: "repeat(1, 1fr)",
          },
        }}
      >
        {skillCategories.map((category, index) => (
          <div key={index} className="skill-category">
            <h3>{category.title}</h3>
            <div className="skills-grid">
              {category.skills.map((skill, skillIndex) => (
                <div key={skillIndex} className="skill-item">
                  <span className="skill-name">{skill.name}</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Skills;
